import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import Home from "./components/Home";
import Gallery from "./components/Gallery";
import Contact from "./components/Contact";
import Courses from "./components/Courses";
import Navigation from "./components/Navigation";
import GlobalStyle from "./GlobalStyle";
import { theme } from "./theme";
import WhatsAppButton from "./components/WhatsAppButton";
import About from "./components/About";

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <GlobalStyle />
        <div>
        <Navigation />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/courses" element={<Courses />} />
          <Route path="/about" element={<About />} />
        </Routes>
          <WhatsAppButton />
      </div>
    </Router>
    </ThemeProvider>
  );
};

export default App;
